import MonitoringServiceOrderDetailModal from './monitoring-service-order-detail-modal.vue'
export default MonitoringServiceOrderDetailModal
